import { CommandType } from "~app/common/services/cqs/CommandType";
import { ArbetsorderProduktBaseCommand } from "./ArbetsorderProduktBaseCommand";
export class JusteraArbetsorderProduktKvantitetCommand extends ArbetsorderProduktBaseCommand {
    justeradKvantitet?: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "JusteraArbetsorderProduktKvantitetCommand";
    constructor(handelssortimentId: number, arbetsorderId: number, produktId: number, justeradKvantitet?: number) {
        super(JusteraArbetsorderProduktKvantitetCommand.$type, CommandType.Replace);
        this.handelssortimentId = handelssortimentId;
        this.arbetsorderId = arbetsorderId;
        this.produktId = produktId;
        this.justeradKvantitet = justeradKvantitet;
    }
}
